import * as React from 'react';
import * as moment from 'moment';
import useCoachNotifications, { PAGE_SIZE } from '@nkr/store/microsites/hooks/use-coach-notifications';
import { notificationStyles } from './styles';

interface IProps {
    contactId: number;
}

const NotificationsPanel: React.FC<IProps> = ({ contactId }) => {
    const [expanded, setExpanded] = React.useState<boolean>(true);
    const [page, setPage] = React.useState<number>(1);
    const { notifications, total, loading } = useCoachNotifications(contactId, page);

    const totalPages = Math.ceil(total / PAGE_SIZE);

    return (
        <div style={notificationStyles.wrapper}>
            <div style={notificationStyles.header} onClick={() => setExpanded(!expanded)}>
                NOTIFICATIONS ({total}) {expanded ? '▾' : '▸'}
            </div>
            <div style={notificationStyles.panel}>
                {expanded && (
                    <>
                        <table style={notificationStyles.table}>
                            <thead>
                                <tr>
                                    <th style={notificationStyles.th}>Date</th>
                                    <th style={notificationStyles.th}>Description</th>
                                    <th style={notificationStyles.th}>Notification</th>
                                    <th style={notificationStyles.th}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td colSpan={4} style={notificationStyles.empty}>Loading...</td>
                                    </tr>
                                )}
                                {!loading && notifications.length === 0 && (
                                    <tr>
                                        <td colSpan={4} style={notificationStyles.empty}>No new notifications</td>
                                    </tr>
                                )}
                                {!loading && notifications.map(n => (
                                    <tr key={n.commId}>
                                        <td style={notificationStyles.tdDate}>
                                            {moment(n.sentByRecipient ? n.sendDateTime : (n.replyDateTime ?? n.sendDateTime)).format('MM/DD/YYYY HH:mm')}
                                        </td>
                                        <td style={notificationStyles.td}>
                                            Message from {n.patientName}
                                        </td>
                                        <td style={notificationStyles.tdMessage}>
                                            {n.sentByRecipient ? n.note : n.reply}
                                        </td>
                                        <td style={notificationStyles.td}>
                                            <a href={`/microsite/coach/${n.micrositeRecipientId}`} style={notificationStyles.replyBtn}>
                                                Reply
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {totalPages > 1 && (
                            <div style={notificationStyles.pagination}>
                                <button
                                    style={notificationStyles.pageBtn}
                                    disabled={page === 1}
                                    onClick={() => setPage(p => p - 1)}
                                >
                                    ‹ Prev
                                </button>
                                <span style={notificationStyles.pageInfo}>
                                    Page {page} of {totalPages}
                                </span>
                                <button
                                    style={notificationStyles.pageBtn}
                                    disabled={page === totalPages}
                                    onClick={() => setPage(p => p + 1)}
                                >
                                    Next ›
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default NotificationsPanel;
